import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import {MyTextInput} from "../../MyTextInput";
import InputLabel from "@mui/material/InputLabel";
import {ErrorMessage} from "formik";
import Select from 'react-select';
import ObjecttypeSelectlist from "../../../shared/ObjecttypeSelectlist";
import {useContext, useEffect, useLayoutEffect, useState} from "react";
import {ProfileContext} from "../../Store";



const styles = {
    itemText: {
        margin: "10px",
        paddingLeft: "30px",
    },
    ListComp: {
        padding: "30px",
        margin: "10px",
    },
    InputLabel: {
        width: "150px"
    },
    selectbox: {
        width: "300px"
    },
    TabBorderStyle: {
        padding: "3px",
        borderRight: "1px solid black",
        borderTop: "1px solid black",
        borderLeft: "1px solid black",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
    }
}

function BimProjectFormList({bimProjectData, setProfileId, profileId, optionsRealestateobject, setSelectedRealestateobject, selectedRealestateobject}) {
    const profile = useContext(ProfileContext);
    const bimProf = profile.profiles;
    const [options, setOptions] = useState([]);

    const onChangeProfile = (selectedOption) => {
        // console.log(selectedOption);
        setProfileId(selectedOption.value);
    }


    useLayoutEffect(() => {
        if (bimProf?.length > 0) {
            setOptions(bimProf.map(prof => ({value: prof.id, label: prof.name})));
        }
    }, [bimProf]);

    // const [optionsRealestateobject, setOptionsRealestateobject] = useState('');


    useEffect(() => {
        if (bimProjectData) {
            setSelectedRealestateobject(bimProjectData.realestateobjectLevelGuid);
        } else {
            setSelectedRealestateobject('');
        }
    }, [bimProjectData, setSelectedRealestateobject]);

    const handleChangeRealestateobject = event => {
        setSelectedRealestateobject(event.target.value);
    };


    return (
        <List>
            <ListItem>

                <MyTextInput
                    autoFocus
                    margin="dense"
                    name="name"
                    type="text"
                    fullWidth
                    required
                    label="Name"
                />
                <ErrorMessage name="name"/>
            </ListItem>

            <ListItem>

                <MyTextInput
                    margin="dense"
                    name="description"
                    type="text"
                    fullWidth
                    label="Beschreibung"
                />
            </ListItem>
            <ListItem>
                <InputLabel sx={styles.InputLabel}>Profil</InputLabel>
                <Select
                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: '300px',
                        }),
                    }}
                    isDisabled={profileId>0}
                    value={
                        options?.filter(option =>
                            option.value === profileId)
                    }
                    onChange={(option) => onChangeProfile(option)}
                    options={options}

                />
            </ListItem>
            <ListItem>
                <InputLabel sx={styles.InputLabel}>Objekt-Ebene</InputLabel>
                <ObjecttypeSelectlist
                    options={optionsRealestateobject}
                    selected={selectedRealestateobject}
                    handleChange={handleChangeRealestateobject}
                    style={styles.selectbox}
                />
            </ListItem>
            <ListItem>
                <InputLabel>Status:&nbsp;</InputLabel>
                <InputLabel>{bimProjectData.status}</InputLabel>
            </ListItem>
            <ListItem>
                <div>Bauteiltypen, die dem Profil zugeordnet sind:</div>

            </ListItem>
            <ListItem style={{display: "block"}}>
                {bimProjectData?.componenttypes?.map((ct) => (
                    <div>{ct.mmsCode} - {ct.name}</div>
                ))}
            </ListItem>


        </List>
    )
}
export default BimProjectFormList;